// extracted by mini-css-extract-plugin
export default {"mid":"CourseCard_mid__Vqu1e","iconList":"CourseCard_iconList__clDzC","bottom":"CourseCard_bottom__ZNkhq","cardKnowMoreBtn":"CourseCard_cardKnowMoreBtn__ZwhYk"};